import React, { useState } from "react";
import { Star, Quote, BadgeCheck, MessageSquareHeart, ChevronLeft, ChevronRight } from "lucide-react";
import { Corners } from "./Hero";
import { useData } from "../data/DataContext";

const DEFAULT_REVIEWS = [
  { name: "Rahul Verma", city: "Lucknow", game: "Rummy Zip", rating: 5, text: "₹88 bonus mila turant, pehla ₹100 withdrawal UPI pe 20 minute mein aa gaya. Link bilkul sahi tha, Telegram wale fake APK se bach gaya." },
  { name: "Priya Sharma", city: "Jaipur", game: "Jeet Spin", rating: 5, text: "Slots aur spin games smooth chalte hain mere Redmi pe. Site pe system requirements pehle se likhe the, isliye install mein koi dikkat nahi hui." },
  { name: "Aman Khan", city: "Hyderabad", game: "Yono 777", rating: 4, text: "Bonus ₹521 ka tha jaisa likha tha. Sirf ek baat - withdrawal ke liye KYC karna pada, par wo bhi 1 din mein ho gaya." },
  { name: "Sneha Patel", city: "Surat", game: "Gold Rummy", rating: 5, text: "Maine 3 apps compare kiye isi page se. Players meter aur bonus side-by-side dekh ke choose karna easy tha." },
  { name: "Vikram Singh", city: "Patna", game: "Spin 101", rating: 4, text: "Download button se seedha official APK mila. Guide mein likha tha ki pehle chhota withdrawal karo - sahi advice thi." },
  { name: "Neha Gupta", city: "Indore", game: "Jaiho 777", rating: 5, text: "Roz naye games add hote hain, New Games tab check karti hoon. Site mobile pe fast khulti hai, koi ads nahi." },
];

const Stars = ({ n }) => (
  <span className="flex gap-0.5">
    {Array.from({ length: 5 }).map((_, i) => (
      <Star key={i} size={14} className={i < n ? "text-[#ffb224]" : "text-[#1c5f35]"} fill="currentColor" />
    ))}
  </span>
);

const ReviewCard = ({ r, i }) => (
  <article
    data-testid={`review-card-${i}`}
    className="group relative overflow-hidden flex flex-col bg-gradient-to-br from-[#0b4d24] via-[#073c1b] to-[#052b14] border border-[#1c5f35] border-b-[4px] border-b-[#0a3a1b] rounded-2xl p-4 sm:p-5 hover:border-[#ffb224]/60 hover:-translate-y-0.5 active:scale-[0.98] transition-all duration-200"
    style={{ animation: "fadeUp 0.5s ease both", animationDelay: `${(i % 3) * 80}ms` }}
  >
    <Corners inside size="w-4 h-4" color="border-[#ffb224]/70" />
    <Quote size={38} className="absolute -top-1 right-3 text-[#ffb224]/10" fill="currentColor" />
    <div className="flex items-center gap-3">
      <span className="w-11 h-11 rounded-xl bg-[#ffb224] text-[#062a13] font-extrabold text-base flex items-center justify-center border-b-[3px] border-[#b47400] shrink-0">
        {r.name.split(" ").map((w) => w[0]).join("")}
      </span>
      <div className="min-w-0">
        <p className="text-white font-extrabold text-[15px] leading-tight flex items-center gap-1.5">
          {r.name} <BadgeCheck size={15} className="text-[#ffb224] shrink-0" />
        </p>
        <p className="text-emerald-50/60 text-xs">{r.city} · plays <span className="text-[#ffb224] font-semibold">{r.game}</span></p>
      </div>
    </div>
    <Stars n={r.rating} />
    <p className="mt-2.5 text-emerald-50/80 text-[14px] leading-relaxed flex-1">"{r.text}"</p>
    <span className="mt-3 inline-flex items-center gap-1.5 self-start text-[11px] font-bold text-emerald-300 bg-emerald-400/10 border border-emerald-400/20 px-2.5 py-1 rounded-full">
      <BadgeCheck size={12} /> Verified download
    </span>
  </article>
);

export const Reviews = () => {
  const { settings } = useData();
  const REVIEWS = settings.reviews && settings.reviews.length ? settings.reviews : DEFAULT_REVIEWS;
  const [page, setPage] = useState(0);
  const perPage = 3;
  const pages = Math.max(1, Math.ceil(REVIEWS.length / perPage));
  const avg = (REVIEWS.reduce((a, r) => a + r.rating, 0) / REVIEWS.length).toFixed(1);

  return (
    <section data-testid="reviews-section" className="max-w-6xl mx-auto px-4 mt-12">
      <div className="flex flex-wrap items-end justify-between gap-3 mb-5">
        <div>
          <h2 className="text-2xl sm:text-3xl font-extrabold text-white flex items-center gap-3">
            <span className="w-9 h-9 sm:w-10 sm:h-10 rounded-xl bg-[#ffb224] text-[#062a13] flex items-center justify-center border-b-[3px] border-[#b47400] shrink-0"><MessageSquareHeart size={18} strokeWidth={2.5} /></span>
            Player Reviews
          </h2>
          <p className="text-emerald-50/65 text-sm mt-1.5 flex items-center gap-2">
            <Stars n={5} /> <span className="text-[#ffb224] font-extrabold">{avg}</span> average from {REVIEWS.length * 212}+ players
          </p>
        </div>
        <div className="flex items-center gap-2">
          <button data-testid="reviews-prev" onClick={() => setPage((page - 1 + pages) % pages)} aria-label="Previous reviews" className="w-10 h-10 rounded-xl bg-[#15562e] text-white flex items-center justify-center border-b-[3px] border-[#0a3a1b] active:border-b-0 active:translate-y-[3px] transition-all"><ChevronLeft size={18} /></button>
          <button data-testid="reviews-next" onClick={() => setPage((page + 1) % pages)} aria-label="Next reviews" className="w-10 h-10 rounded-xl bg-[#ffb224] text-[#062a13] flex items-center justify-center border-b-[3px] border-[#b47400] active:border-b-0 active:translate-y-[3px] transition-all"><ChevronRight size={18} /></button>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-3 sm:gap-4">
        {REVIEWS.slice(page * perPage, page * perPage + perPage).map((r, i) => (
          <ReviewCard key={r.name + i} r={r} i={page * perPage + i} />
        ))}
      </div>

      <div className="flex justify-center gap-1.5 mt-4">
        {Array.from({ length: pages }).map((_, i) => (
          <button key={i} data-testid={`reviews-dot-${i}`} onClick={() => setPage(i)} aria-label={`Reviews page ${i + 1}`} className={`h-2 rounded-full transition-all ${i === page ? "w-6 bg-[#ffb224]" : "w-2 bg-[#1c5f35]"}`} />
        ))}
      </div>
    </section>
  );
};

export default Reviews;
